import { useLocation, useHistory } from 'react-router';
import { useCallback } from 'react';

function useUrlQuery() {
	return new URLSearchParams(useLocation().search);
}

export const useModifySearchParams = () => {
	const history = useHistory();

	const setSearchParam = useCallback(
		(key, value) => {
			const currentLocation = history.location; // Get fresh location from history
			const searchParams = new URLSearchParams(currentLocation.search);
			searchParams.set(key, value);
			history.push({ ...currentLocation, search: searchParams.toString() });
		},
		[history]
	);

	const removeSearchParam = useCallback(
		(key) => {
			const currentLocation = history.location; // Get fresh location from history
			const searchParams = new URLSearchParams(currentLocation.search);
			searchParams.delete(key);
			history.push({ ...currentLocation, search: searchParams.toString() });
		},
		[history]
	);

	return {
		setSearchParam,
		removeSearchParam,
	};
};

export const useSearchParams = () => {
	const query = useUrlQuery();

	const getSearchParam = (parameterName) => {
		return query.get(parameterName) || null;
	};

	return {
		getSearchParam,
	};
};

export default useSearchParams;
